<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrightcc"><a id="ch00_fm04_copy"></a><a id="page_iv"></a>Copyright © 1988 by Bharati Mukherjee</p>
<p class="copyrightc">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="copyrightcc"><em>Printed in the United States of America</em></p>
<p class="copyrightc">Stories in this book first appeared in <em>Playboy, Mother Jones, Chelsea, The Literary Review;</em> and have been reprinted in <em>Best Canadian Stories, Best American Stories of 1987</em>, and <em>Editor’s Choice, 1987.</em></p>
<p class="copyrightcc">This work was completed under a grant from<br/>the National Endowment for the Arts.</p>
<p class="copyrightcc">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyrightc">Mukherjee, Bharati.</p>
<p class="copyrightcc">The middleman and other stories / by Bharati Mukherjee.</p>
<p class="copyrightc">                                   p. cm.</p>
<p class="copyrightcc">Contents: The middleman—A wife’s story—Loose ends—<br/>Orbiting—Fighting for the rebound—The tenant—Fathering—<br/>Jasmine—Danny’s girls—Buried lives—The management of grief.</p>
<p class="copyrightc">                                eBook ISBN-13: 978-0-8021-9634-7</p>
<p class="copyrightc">                                I. Title.<br/>                         PR9499.3.M77M5 1988<br/>                         813’.54—dcl9                                         87-35048</p>
<p class="copyrightcc">Grove Press<br/>an imprint of Grove/Atlantic, Inc.<br/>841 Broadway<br/>New York, NY 10003</p>
<p class="copyrightcc">Distributed by Publishers Group West</p>
<p class="copyrightcc"><span class="weblink"><a class="nounder" href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?47073906